"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var FormatUtils_1 = require("../../displayUtils/FormatUtils");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var LineageCartoucheStyles_1 = require("../../style/LineageCartoucheStyles");
var LineageConfiguration_1 = require("../placePage/LineageConfiguration");
var CenteredSpinner_1 = require("../widgets/CenteredSpinner");
var FilterIndicatorWithClearButton_1 = require("./FilterIndicatorWithClearButton");
var LineageAnchor_1 = require("./LineageAnchor");
var LineageCartouche_1 = require("./LineageCartouche");
var LineageNavStyles_1 = require("./LineageNavStyles");
var SingleLineageItem_1 = require("./SingleLineageItem");
var LineageNav = /** @class */ (function (_super) {
    __extends(LineageNav, _super);
    function LineageNav() {
        var _a;
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rendererForLineageSectionType = (_a = {},
            _a[LineageConfiguration_1.LineageSectionType.Group] = _this.renderCartouche.bind(_this),
            _a[LineageConfiguration_1.LineageSectionType.Anchor] = _this.renderAnchor.bind(_this),
            _a[LineageConfiguration_1.LineageSectionType.Owners] = _this.renderSingleItem.bind(_this),
            _a);
        return _this;
    }
    LineageNav.prototype.hasInitialLoadCompleted = function () {
        return !!this.props.unfilteredCounts;
    };
    LineageNav.prototype.render = function () {
        var contents = this.hasInitialLoadCompleted() ? (React.createElement(React.Fragment, null,
            this.renderHeader(),
            this.renderNavItems())) : this.renderLoadingIndicator();
        return (React.createElement(LineageNavStyles_1.LineageNavContainer, null,
            React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true, additionalClassNames: [LineageNavStyles_1.lineageNavCssClass] }, contents)));
    };
    LineageNav.prototype.renderLoadingIndicator = function () {
        return React.createElement(CenteredSpinner_1.CenteredFadeInSpinner, null);
    };
    LineageNav.prototype.renderHeader = function () {
        return (React.createElement(LineageNavStyles_1.LineageNavHeader, null,
            React.createElement(LayoutComponents_1.HorizontalFlexContainer, { additionalClassNames: [LineageNavStyles_1.lineageHeaderClass] },
                React.createElement("span", null, Localize_1.Messages.LineageNavHeader()),
                this.props.numberOfFilters > 0 ?
                    React.createElement(FilterIndicatorWithClearButton_1.FilterIndicatorWithClearButton, { clearFilters: this.props.clearFilters, numberOfFilters: this.props.numberOfFilters })
                    : null)));
    };
    LineageNav.prototype.renderNavItems = function () {
        var _this = this;
        var sectionsToRender = this.getItemsWithNonzeroCounts();
        var renderedSections = sectionsToRender.map(function (section) { return _this.rendererForLineageSectionType[section.sectionType](section); });
        var sectionsWithConnectors = [];
        renderedSections.forEach(function (section, i) {
            if (i !== 0) {
                sectionsWithConnectors.push(React.createElement(LineageCartoucheStyles_1.CartoucheConnectorLine, { key: i }));
            }
            sectionsWithConnectors.push(section);
        });
        return sectionsWithConnectors;
    };
    LineageNav.prototype.getItemsWithNonzeroCounts = function () {
        var _this = this;
        var configSections = this.props.lineageConfiguration;
        var sectionsWithFilteredItems = configSections.map(function (section) {
            // Certain section types should never be removed
            if (section.sectionType === LineageConfiguration_1.LineageSectionType.Anchor || section.sectionType === LineageConfiguration_1.LineageSectionType.Owners) {
                return section;
            }
            var filteredItems = section.items.filter(function (item) { return _this.props.unfilteredCounts && item.count(_this.props.unfilteredCounts); });
            return __assign(__assign({}, section), { items: filteredItems });
        });
        var filteredSections = sectionsWithFilteredItems.filter(function (section) { return section.items.length > 0; });
        return filteredSections;
    };
    LineageNav.prototype.renderCartouche = function (section) {
        var _this = this;
        var lineageItems = section.items.map(function (item) { return _this.getLineageItemProps(item, section); });
        return React.createElement(LineageCartouche_1.LineageCartouche, { lineageItems: lineageItems, key: section.key });
    };
    LineageNav.prototype.renderAnchor = function (section) {
        var item = section.items[0]; // Anchor sections should have only one item
        return React.createElement(LineageAnchor_1.LineageAnchor, __assign({}, this.getAnchorProps(item, section)));
    };
    LineageNav.prototype.renderSingleItem = function (section) {
        var item = section.items[0]; // Single-item sections should have only one item
        return React.createElement(SingleLineageItem_1.SingleLineageItem, __assign({}, this.getLineageItemProps(item, section)));
    };
    LineageNav.prototype.getLineageItemProps = function (item, section) {
        var unfilteredCount = this.props.unfilteredCounts && item.count(this.props.unfilteredCounts);
        var filteredCount = this.props.filteredCounts && item.count(this.props.filteredCounts);
        return {
            key: item.lineageItemType,
            label: FormatUtils_1.messageWithOrWithoutCount(this.props.filteredCounts ? filteredCount : unfilteredCount, item.messagesForLineage),
            countLoading: this.props.numberOfFilters > 0 && this.props.countsLoading,
            filteredCount: filteredCount,
            unfilteredCount: unfilteredCount,
            lineageItemType: item.lineageItemType,
            isCurrentPane: LineageConfiguration_1.lineageItemKey({ lineageItem: item, lineageSection: section }) === this.props.activeLineageItemKey,
            linkHref: item.path(this.props.urls, this.props.itemId) + this.props.urlSearchValue,
            buttonAltText: item.messagesForLineage.withoutCount(),
        };
    };
    LineageNav.prototype.getAnchorProps = function (item, section) {
        return {
            key: item.lineageItemType,
            label: FormatUtils_1.messageWithOrWithoutCount(this.props.anchorCount, item.messagesForLineage),
            lineageItemType: item.lineageItemType,
            isCurrentPane: LineageConfiguration_1.lineageItemKey({ lineageItem: item, lineageSection: section }) === this.props.activeLineageItemKey,
            linkHref: item.path(this.props.urls, this.props.itemId) + this.props.urlSearchValue,
            buttonAltText: item.messagesForLineage.withoutCount(),
            isFilteredOnThisType: item.lineageItemType === this.props.filteredOnItemType,
            anchorName: this.props.anchorName,
            selectedItemCount: this.props.numberOfFilters,
        };
    };
    return LineageNav;
}(React.PureComponent));
exports.LineageNav = LineageNav;
//# sourceMappingURL=LineageNav.js.map